/** Transient messages (06 §8.1, z 50). */
import { t } from '@tarock/i18n';
import { useEffect } from 'preact/hooks';
import { tableStore } from '../stores/table';

const TOAST_MS = 4000;

/** Shows `tableStore.toast` for a few seconds (or its own `ms`), announced politely. */
export function Toasts() {
  const toast = tableStore.toast.value;
  useEffect(() => {
    if (!toast) {
      return;
    }
    const id = setTimeout(() => {
      if (tableStore.toast.value === toast) {
        tableStore.toast.value = null;
      }
    }, toast.ms ?? TOAST_MS);
    return () => clearTimeout(id);
  }, [toast]);
  return (
    <div class="toast-stack" role="status" aria-live="polite">
      {toast && <div class="toast">{toast.text ?? t(toast.key)}</div>}
    </div>
  );
}
